
import { Modal, Button } from 'react-bootstrap';
import logger from '../../../utils/logger';


// import './modal.css'
const ReactBootstrapModal = ({
    children,
    toggleModal,
    showModal,
    contentClass,
    dialogClass,
    modalClass,

}) => {


    return (
        <Modal
            className={modalClass}
            show={showModal}
            onHide={toggleModal}
            contentClassName={contentClass}
            onClick={(e) => {
        // Si el target del clic es el contenedor mismo y no sus hijos (el diálogo)
        if (e.target === e.currentTarget) {
            logger.debug("Se hizo clic fuera del contenido del modal");
        }
    }}
            // dialogClassName={dialogClass}

            dialogClassName={`modal-dialog-centered ${dialogClass}`}
        >

            {children}
        </Modal>
    );
};

export default ReactBootstrapModal;
